import { MetadataEntityData } from '../model/metadata.entity.data';
import { MetadataEntityFieldData } from '../model/metadata.entity.field.data';
import { MetadataEntityFieldType } from '../model/metadata.entity.field.types';
import { getMetadataEntityFieldType } from '../utilities';

interface ParentField {
    path: string;
    field: MetadataEntityFieldData;
}

export class MetadataEntityFieldDomain {

    public get name() {
        return this.metadata.name;
    }

    public get displayName() {
        return this.metadata.displayName;
    }

    public get type() {
        return this.metadata.type;
    }

    public get module() {
        return this.metadata.module;
    }

    public readonly fields: Record<string, MetadataEntityFieldData> = {};
    public readonly uiFields: Record<string, MetadataEntityFieldData> = {};
    public readonly bulkUpdateFields: Record<string, MetadataEntityFieldData> = {};
    public readonly customFields: Record<string, MetadataEntityFieldData> = {};

    constructor(
        public readonly metadata: MetadataEntityData
    ) {

        if (!metadata?.fields) return;
        this.fields = this.getFields('default', {}, null, metadata.fields);
        this.uiFields = this.getFields('ui', {}, null, metadata.fields);
        this.bulkUpdateFields = this.getFields('bulk', {}, null, metadata.fields);
        this.customFields = this.getFields('customFields', {}, null, metadata.fields);

    }

    private getFields(getType: 'default' | 'ui' | 'bulk' | 'customFields', fieldMap: Record<string, MetadataEntityFieldData>, parent: ParentField | null, fields: MetadataEntityFieldData[]) {

        if (!fields) return fieldMap;

        for (const field of fields) {

            let safeField = { ...field };

            switch (getType) {
                case 'bulk': {
                    const bulkOverride = field.bulkImportOverrides ?? {};
                    safeField = { ...field, ...bulkOverride };
                    break;
                }

                case 'customFields':
                case 'ui': {
                    const uiOverride = field.uiOverrides ?? {};
                    safeField = { ...field, ...uiOverride };
                    break;
                }

            }

            let path = parent?.path
                ? `${parent?.path}.${safeField.name}`
                : safeField.name;
            ;

            safeField.readonly = parent?.field?.readonly
                ? parent?.field?.readonly
                : safeField.readonly;

            const type = getMetadataEntityFieldType(safeField);

            switch (type) {
                case MetadataEntityFieldType.EmbeddedEntity: {
                    this.getFields(getType, fieldMap, { path, field }, safeField.typeData?.fields);
                    break;
                }

                case MetadataEntityFieldType.CustomField: {
                    path = `customFields.${safeField.name}`;
                    break;
                }

                // default: {
                //     fieldMap[path] = safeField;
                // }
            }

            if (getType === 'customFields' && type !== MetadataEntityFieldType.CustomField) {
                path = null;
            }

            if (path)
                fieldMap[path] = safeField;


        }

        return fieldMap;
    }
}